export default function calculateDuration(schedule) {
  if (!schedule) return 1;

  const duration = schedule?.length > 0 ? schedule.length : 1;

  // Buy 3 get 1 off special
  // Very fancy math
  return duration - Math.floor(duration / 3);
}
